import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeViewComponent } from './components/common/homeView.component';
import { ForbiddenViewComponent } from './components/common/forbiddenView.component';
import { CertificateFormComponent } from './components/certificates/certificateForm.component';
import { CertificateRenewalFormComponent } from './components/certificates/certificateRenewalForm.component';

import { TestCertificateComponent } from './components-to-remove/testCertificate.component';
import { LoginFormComponent } from './components/account/loginForm.component';
import { LogoutViewComponent } from './components/account/logoutView.component';
import { AccountViewComponent } from './components/account/accountView.component';
import { ProfileViewComponent } from './components/account/profileView.component';
import { ResetPasswordFormComponent } from './components/account/resetPasswordForm.component';
import { ConfirmResetPasswordFormComponent } from './components/account/confirmResetPasswordForm.component';


const appRoutes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full', data: { title: 'Welcome!' } },
    { path: 'home', component: HomeViewComponent, data: { title: 'Welcome!' } },
    { path: 'certificate', component: CertificateFormComponent, data: { title: 'Certificate Management' } },
    { path: 'certificate-renew', component: CertificateRenewalFormComponent, data: { title: 'Certificate Management' } },
    { path: 'test-certificate', component: TestCertificateComponent, data: { title: 'Test Page' } },
    { path: 'login', component: LoginFormComponent, data: { title: 'Login Page' } },
    { path: 'logout', component: LogoutViewComponent, data: { title: 'Logout Page' } },
    { path: 'account', component: AccountViewComponent, data: { title: 'Account Page' } },
    { path: 'profile', component: ProfileViewComponent, data: { title: 'Account Page' } },
    { path: 'reset-password', component: ResetPasswordFormComponent, data: { title: 'Reset Password' } },
    { path: 'confirm-reset-password', component: ConfirmResetPasswordFormComponent, data: { title: 'Confirm Reset Password' } },
    { path: 'page-not-found', component: ForbiddenViewComponent, data: { title: 'Page not found' } },
    { path: '**', redirectTo: 'home' }
];

export const Routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/app.routing.ts